import { render, staticRenderFns } from "./costHelpThirtyTage.vue?vue&type=template&id=0b2536fa&"
import script from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2536fa')) {
      api.createRecord('0b2536fa', component.options)
    } else {
      api.reload('0b2536fa', component.options)
    }
    module.hot.accept("./costHelpThirtyTage.vue?vue&type=template&id=0b2536fa&", function () {
      api.rerender('0b2536fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-270j5iEt9DSqh/JS/costHelpThirtyTage.vue"
export default component.exports